export const QUOTE_STATUS = {
  draft: "Draft",
  pending_approval: "Awaiting Approval",
  approved: "Approved",
  rejected: "Changes Requested",
};
export const GST_RATES = [0, 5, 12, 18, 28];
export const EDITABLE = ["draft", "rejected"];

const r2 = (n) => Math.round(n * 100) / 100;

export function computeTotals(items, state) {
  const inter = !["uttar pradesh", "up"].includes((state || "").trim().toLowerCase());
  let sub = 0;
  let gst = 0;
  const lines = items.map((it) => {
    const taxable = r2((Number(it.qty) || 0) * (Number(it.rate) || 0) * (1 - (Number(it.discount_pct) || 0) / 100));
    const g = r2((taxable * (Number(it.gst_rate) || 0)) / 100);
    sub += taxable;
    gst += g;
    return { taxable, gst: g, total: r2(taxable + g) };
  });
  const raw = r2(sub + gst);
  const grand = Math.round(raw);
  const half = r2(gst / 2);
  return {
    lines, inter, subtotal: r2(sub), cgst: inter ? 0 : half, sgst: inter ? 0 : r2(gst - half), igst: inter ? r2(gst) : 0,
    round_off: r2(grand - raw), grand_total: grand,
  };
}

export const blankItem = () => ({ product_id: null, name: "", description: "", hsn: "", unit: "Nos", qty: 1, rate: 0, discount_pct: 0, gst_rate: 18 });

export const toPayload = (f) => ({
  ...f,
  items: f.items.map((it) => ({
    ...it, qty: Number(it.qty), rate: Number(it.rate), discount_pct: Number(it.discount_pct || 0), gst_rate: Number(it.gst_rate),
  })),
  valid_until: f.valid_until || null,
});
